import React from "react";
import OfficeForm from "./OfficeForm";

export default function EditOffice() {
  return <OfficeForm type="Edit" />;
}
